import { PromotionType } from "@sellar-io/api-v2/types";

import { z } from "zod";

import dayjs from "dayjs";

export type GlobalPromotionType = Pick<
  PromotionType,
  "id" | "startAt" | "endAt" | "isActive" | "rewardRule" | "name"
>;

export type GlobalPromotionsTabProps = {
  promotionsBasePath?: string;
};

export type PromotionFormSchemaType = z.infer<typeof PromotionFormSchema>;

export type DeleteGlobalPromotionDialogProps = {
  open: boolean;
  promotion: GlobalPromotionType;
  onDismiss: () => void;
};

export type PromotionFormProps = {
  mode: "create" | "update";
  initialData: PromotionFormSchemaType;
  errorMessage: string;
  metadata: { overlappingPromotionsByDateCount: number };
  isSubmitting: boolean;
  onChangeDates: (_dates: { startAt: string; endAt: string }) => void;
  onSubmit: (_formData: PromotionFormSchemaType) => void;
};

export const PromotionFormSchema = z.object({
  name: z.string().min(1, { message: "Set a name for this promotion" }),
  startAt: z
    .string()
    .min(1, { message: "Set a start date for this promotion" }),
  endAt: z.string().min(1, { message: "Set an end date for this promotion" }),
  rewardRule: z
    .string()
    .min(1, { message: "Select a reward rule for this promotion" }),
  isActive: z.boolean(),
});

export const defaultPromotionFormData: PromotionFormSchemaType = {
  name: "",
  startAt: "",
  endAt: "",
  rewardRule: "",
  isActive: false,
};

export const getDatesOverlap = ({
  startDateA,
  endDateA,
  startDateB,
  endDateB,
}: {
  startDateA: Date | null;
  endDateA: Date | null;
  startDateB: Date | null;
  endDateB: Date | null;
}) => {
  if (!startDateA || !startDateB || !endDateA || !endDateB) return false;
  return (
    dayjs(startDateA).isBetween(startDateB, endDateB, null, "[]") ||
    dayjs(startDateB).isBetween(startDateA, endDateA, null, "[]")
  );
};

export const getRewardRuleDescription = (
  rewardRule: PromotionType["rewardRule"],
) => {
  switch (rewardRule) {
    case "one_of":
      return "Customer can redeem up to 1 eligible reward";
    case "all_of":
      return "Customer can redeem any number of eligible rewards";
  }
};
